export interface TourBox { left: number; top: number; right: number; bottom: number; width: number; height: number; }
export interface CoachPosition { left: number; top: number; side: 'left' | 'right' | 'below' | 'above'; }

// Use actual rendered card dimensions so longer translations remain inside the viewport.
export function positionTourCoach(target: TourBox, viewport: { width: number; height: number },
  card: { width: number; height: number }, preferred: 'left' | 'right'): CoachPosition {
  const margin = 12, gap = 20, header = 94;
  const maxLeft = Math.max(margin, viewport.width - card.width - margin);
  const maxTop = Math.max(margin, viewport.height - card.height - margin);
  const clampTop = (top: number) => Math.max(Math.min(header, maxTop), Math.min(top, maxTop));
  if (preferred === 'left' && target.left - gap - card.width >= margin) {
    return { left: target.left - gap - card.width, top: clampTop(target.top), side: 'left' };
  }
  if (preferred === 'right' && target.right + gap + card.width <= viewport.width - margin) {
    return { left: target.right + gap, top: clampTop(target.top), side: 'right' };
  }
  const below = target.bottom + gap + card.height <= viewport.height - margin;
  return { left: Math.max(margin, Math.min(target.left, maxLeft)),
    top: below ? clampTop(target.bottom + gap) : clampTop(target.top - gap - card.height), side: below ? 'below' : 'above' };
}
